var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.00053C21 8.61506 20.5104 9.10459 19.8957 9.10459H3.7687L8.77974 14.1145C9.20687 14.5416 9.20687 15.2498 8.77974 15.6769C8.56096 15.8956 8.27967 15.9998 7.99839 15.9998C7.7171 15.9998 7.43582 15.8956 7.21704 15.6769L0.320352 8.78171C-0.106784 8.35467 -0.106784 7.65682 0.320352 7.21936L7.20662 0.324199C7.63376 -0.102843 8.34218 -0.113258 8.76932 0.324199C9.19645 0.751241 9.20687 1.44909 8.76932 1.88655L3.7687 6.89647H19.8957C20.5104 6.89647 21 7.39643 21 8.00053Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.e0c956c1e5cf36099e89bff499cfa4e6.svg";
export { ForwardRef as ReactComponent };